import {IOnChanges, IOnChangesObject} from "angular";
import {Contract} from "../../../../../portfolio/templates/ticket/place-order-wizard/models/Contract";
import {PriceStrategy} from "../../../../inputs/price/input/PriceStrategy";
import {SpreadSummary} from "../../../../../types/OrderSpread";
import {PriceStrategyService} from "../../../../inputs/price/service/PriceStrategyService";

export const OptionTradeDescription = "tfOptionTradeDescription";

export function optionTradeDescription() {
    return {
        template,
        bindings: {
            trade: "<",
            contract: "<",
            spread: "<"
        },
        controller: OptionTradeDescriptionController,
        controllerAs: "ctrl"
    };
}

export class OptionTradeDescriptionController implements IOnChanges {

    public trade: Trade;
    public contract: Contract;
    public spread: SpreadSummary;

    public strategy: PriceStrategy;

    private strategyService: PriceStrategyService;

    /** @ngInject */
    public constructor(priceStrategyService: PriceStrategyService) {
        this.strategyService = priceStrategyService;
    }

    public $onChanges(changes: IOnChangesObject): void {
        if (changes.contract != null && this.contract != null) {
            this.strategy = this.strategyService.forCode(this.contract.code);
        }
    }
}

const template = `
    <div class="description">
        <div class="row">
            <div class="col-xs-12">
                <span style="font-size: 12px;">
                    {{ ctrl.trade.code || ctrl.trade.contract.code }}
                    | {{ ctrl.contract.cvf | number : 0 }} SHARES
                    <span ng-if="ctrl.spread.theo != null">
                    | {{ ctrl.spread.theo | strategyPrice : ctrl.strategy : true }} THEO
                    </span>
                </span>
            </div>
        </div>
    </div>
`;
